import PropTypes from "prop-types"

import { cn } from "styles/utils"

const Shimmer = ({ className, ...props }) => (
  <div className={cn("shimmer bg-[position:0_0]", className)} {...props} />
)

Shimmer.propTypes = {
  className: PropTypes.string,
}

export default Shimmer
